import Button, { IButtonProps } from '@/shared/Buttons/Button'
import PlusIcon from '@/assets/icons/plus.svg?react'
import cn from '@/utils/cn.ts'

interface IProps {
  onClick: () => void
  text: string
  type?: IButtonProps['type']
  fullWidth?: IButtonProps['fullWidth']
}

const CreateEntityButton = (props: IProps) => {
  const type = props.type || 'primary'
  return (
    <Button
      size="default"
      type={type}
      text={props.text}
      onClick={props.onClick}
      fullWidth={props.fullWidth}
      icon={
        <PlusIcon
          className={cn({
            'text-white': type === 'primary',
            'text-default': type === 'default',
          })}
        />
      }
    />
  )
}

export default CreateEntityButton
